import Accordion from '../../plugins/accordion.js';
const elements = document.querySelectorAll(".js-accordion");
for (const element of elements) {
  let accordion = new Accordion(element, {
    multipleOpen: true,
    defaultOpenPanels: [0],
    easing: "cubic-bezier(0.4, 0, 0.2, 1)",
    duration: ".4s",
    onOpen: (trigger, panel) => {},
    onClose: (trigger, panel) => {}
  });
}

// accordion.destroy()
// accordion.init()
